import { useCallback, useEffect, useMemo, useRef, useState } from "react";

export function useDialogForm(initialState) {
  const initial = useMemo(() => initialState, []);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState(initial);
  const didInitRef = useRef(false);

  const onOpenChange = useCallback((e) => setOpen(!!e.open), []);
  const close = useCallback(() => setOpen(false), []);
  const reset = useCallback(() => setForm(initial), [initial]);

  const openWith = useCallback((seed) => {
    if (seed) {
      if (typeof seed === "function") setForm((prev) => seed(prev));
      else setForm((prev) => ({ ...prev, ...seed }));
    }
    setOpen(true);
  }, []);

  const setField = useCallback((key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  }, []);

  const bind = useCallback((key) => ({ value: form[key] ?? "", onChange: (e) => setField(key, e.target.value) }), [form, setField]);

  const initOnce = useCallback((fn) => {
    if (!open || didInitRef.current) return;
    fn();
    didInitRef.current = true;
  }, [open]);

  useEffect(() => {
    if (!open) didInitRef.current = false;
  }, [open]);

  return { open, setOpen, onOpenChange, openWith, close, reset, form, setForm, setField, bind, initOnce };
}
